import React from 'react';
import QRGenerator from './QRGenerator';

export default function WifiQR() {
  return (
    <div className="flex flex-col gap-12 w-full max-w-4xl mx-auto font-sans">
      <section className="text-center max-w-2xl mx-auto flex flex-col gap-4 py-4">
        <span className="self-center px-3 py-1 rounded-full bg-indigo-600/10 text-indigo-400 border border-indigo-500/20 text-xs font-semibold uppercase tracking-wider">
          Instant Hotspot Connections
        </span>
        <h1 className="text-4xl md:text-5xl font-black tracking-tight leading-tight bg-gradient-to-r from-blue-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent">
          Free WiFi QR Code Generator
        </h1>
        <p className="text-gray-400 text-sm md:text-base leading-relaxed">
          Design custom network access QR codes for coffee shops, guest hotels, offices, and homes. Let guests scan to connect instantly without typing complex passwords.
        </p>
      </section>

      <section className="w-full">
        <QRGenerator defaultTab="wifi" hideTabs={true} />
      </section>

      <section className="border-t border-gray-900 pt-10 flex flex-col gap-6 max-w-3xl mx-auto text-left">
        <div className="flex flex-col gap-3 bg-gray-900/20 border border-gray-900 rounded-2xl p-6">
          <h3 className="text-lg font-bold text-gray-200">How-To Steps:</h3>
          <ol className="flex flex-col gap-3 text-sm text-gray-400 list-decimal list-inside">
            <li>
              <strong className="text-gray-300">Enter Network Name:</strong> Input the exact SSID name of your Wi-Fi router.
            </li>
            <li>
              <strong className="text-gray-300">Enter Password:</strong> Supply your network password security key safely.
            </li>
            <li>
              <strong className="text-gray-300">Download:</strong> Instantly generate and download your custom Wi-Fi QR card.
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-4 text-sm text-gray-400 leading-relaxed">
          <h2 className="text-lg font-bold text-gray-200">Security-First Guest Access</h2>
          <p>
            Sharing your guest Wi-Fi hotspot with a QR code eliminates password spelling confusion and reduces team workload. Simply enter your network details and choose WPA/WPA2 security.
          </p>
          <p>
            Our privacy-centric generator processes your Wi-Fi details 100% inside your web browser. No network credentials or security codes are ever transmitted to external servers, protecting your local system integrity.
          </p>
        </div>
      </section>
    </div>
  );
}
